"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MathUtil_1 = require("./MathUtil");
class CircularIterator {
    constructor(values, startingIndex) {
        this.values = values;
        this.i = startingIndex - this.getIncrementAmount();
    }
    static of(values, startingIndex = 0) {
        return new CircularIterator(values, startingIndex);
    }
    reverse() {
        const amount = this.getIncrementAmount();
        const it = new CircularIterator(this.values, this.i + this.getIncrementAmount());
        it.getIncrementAmount = () => -amount;
        return it;
    }
    [Symbol.iterator]() {
        return this;
    }
    getValues() {
        return this.values;
    }
    getCycleLength() {
        return this.values.length;
    }
    getIncrementAmount() {
        return CircularIterator.DEFAULT_INCREMENT_AMOUNT;
    }
    increment() {
        this.i = MathUtil_1.default.floorMod(this.i + this.getIncrementAmount(), this.getCycleLength());
    }
    getCurrentValue() {
        return this.getValues()[this.i];
    }
    next() {
        this.increment();
        return { value: this.getCurrentValue(), done: false };
    }
}
CircularIterator.DEFAULT_INCREMENT_AMOUNT = 1;
exports.default = CircularIterator;
